import { ActivityStep } from './new-activity-creation-state'

export enum NewActivitySectionType {
    ACTIVITY_TYPE = 'activityType',
    NEWS_TYPE = 'subType',
    TASK_TYPE = 'subType',
    MAIN_INFO = 'mainInfo',
    ACTION = 'action',
    DISTRIBUTION = 'distribution',
    SCHEDULING = 'scheduling',
    EDITING_REASON = 'editingReason',
    POINTS_ASSIGNMENT = 'pointsAssignment',
}

export const NewTaskStepNavigation = {
    [NewActivitySectionType.EDITING_REASON]: {
        next: NewActivitySectionType.MAIN_INFO,
    },
    [NewActivitySectionType.MAIN_INFO]: {
        next: NewActivitySectionType.ACTION,
    },
    [NewActivitySectionType.ACTION]: {
        next: NewActivitySectionType.DISTRIBUTION,
        back: NewActivitySectionType.MAIN_INFO,
    },
    [NewActivitySectionType.DISTRIBUTION]: {
        next: NewActivitySectionType.POINTS_ASSIGNMENT,
        back: NewActivitySectionType.ACTION,
    },
    [NewActivitySectionType.POINTS_ASSIGNMENT]: {
        next: NewActivitySectionType.SCHEDULING,
        back: NewActivitySectionType.DISTRIBUTION,
    },
    [NewActivitySectionType.SCHEDULING]: {
        back: NewActivitySectionType.POINTS_ASSIGNMENT,
    },
}

export const NewSurveyTaskStepNavigation = {
    [NewActivitySectionType.EDITING_REASON]: {
        next: NewActivitySectionType.MAIN_INFO,
    },
    [NewActivitySectionType.NEWS_TYPE]: {
        next: NewActivitySectionType.MAIN_INFO,
    },
    [NewActivitySectionType.MAIN_INFO]: {
        next: NewActivitySectionType.ACTION,
    },
    [NewActivitySectionType.ACTION]: {
        next: NewActivitySectionType.POINTS_ASSIGNMENT,
        back: NewActivitySectionType.MAIN_INFO,
    },
    [NewActivitySectionType.POINTS_ASSIGNMENT]: {
        next: NewActivitySectionType.SCHEDULING,
        back: NewActivitySectionType.ACTION,
    },
    [NewActivitySectionType.SCHEDULING]: {
        back: NewActivitySectionType.POINTS_ASSIGNMENT,
    },
}

export const NewNewsStepNavigation = {
    [NewActivitySectionType.EDITING_REASON]: {
        next: NewActivitySectionType.MAIN_INFO,
    },
    [NewActivitySectionType.NEWS_TYPE]: {
        next: NewActivitySectionType.MAIN_INFO,
    },
    [NewActivitySectionType.MAIN_INFO]: {
        next: NewActivitySectionType.DISTRIBUTION,
        back: NewActivitySectionType.NEWS_TYPE,
    },
    [NewActivitySectionType.DISTRIBUTION]: {
        next: NewActivitySectionType.POINTS_ASSIGNMENT,
        back: NewActivitySectionType.MAIN_INFO,
    },
    [NewActivitySectionType.POINTS_ASSIGNMENT]: {
        next: NewActivitySectionType.SCHEDULING,
        back: NewActivitySectionType.DISTRIBUTION,
    },
    [NewActivitySectionType.SCHEDULING]: {
        back: NewActivitySectionType.POINTS_ASSIGNMENT,
    },
}

export const NewVisitStepNavigation = {
    [NewActivitySectionType.EDITING_REASON]: {
        next: NewActivitySectionType.MAIN_INFO,
    },
    [NewActivitySectionType.MAIN_INFO]: {
        next: NewActivitySectionType.ACTION,
    },
    [NewActivitySectionType.ACTION]: {
        next: NewActivitySectionType.POINTS_ASSIGNMENT,
        back: NewActivitySectionType.MAIN_INFO,
    },
    [NewActivitySectionType.POINTS_ASSIGNMENT]: {
        next: NewActivitySectionType.SCHEDULING,
        back: NewActivitySectionType.ACTION,
    },
    [NewActivitySectionType.SCHEDULING]: {
        back: NewActivitySectionType.POINTS_ASSIGNMENT,
    },
}

export enum ActivitySection {
    NEWS_ACTIVITY = 'newsActivity',
    TASK_ACTIVITY = 'taskActivity',
    SURVEY_TASK_ACTIVITY = 'surveyTaskActivity',
    VISIT_ACTIVITY = 'visitActivity',
}

export const NewActivityStepLabelMap = {
    [NewActivitySectionType.ACTIVITY_TYPE]: 'modals.new.activity.section.activity.type',
    [NewActivitySectionType.EDITING_REASON]: 'modals.new.activity.task.section.editing.reason',
    [NewActivitySectionType.MAIN_INFO]: 'modals.new.activity.section.main.info',
    [NewActivitySectionType.ACTION]: 'modals.new.activity.section.action',
    [NewActivitySectionType.DISTRIBUTION]: 'modals.new.activity.section.distribution',
    [NewActivitySectionType.POINTS_ASSIGNMENT]: 'modals.new.activity.section.points.assignment',
    [NewActivitySectionType.SCHEDULING]: 'modals.new.activity.section.scheduling',
    [NewActivitySectionType.NEWS_TYPE]: 'modals.new.activity.news.section.news.type',
}

export const taskSectionMap = {}
taskSectionMap[NewActivitySectionType.EDITING_REASON] = {
    label: 'modals.new.activity.task.section.editing.reason',
    key: NewActivitySectionType.EDITING_REASON,
}
taskSectionMap[NewActivitySectionType.MAIN_INFO] = {
    label: 'modals.new.activity.section.main.info',
    key: NewActivitySectionType.MAIN_INFO,
}
taskSectionMap[NewActivitySectionType.ACTION] = {
    label: 'modals.new.activity.section.action',
    key: NewActivitySectionType.ACTION,
}
taskSectionMap[NewActivitySectionType.DISTRIBUTION] = {
    label: 'modals.new.activity.section.distribution',
    key: NewActivitySectionType.DISTRIBUTION,
}
taskSectionMap[NewActivitySectionType.POINTS_ASSIGNMENT] = {
    label: 'modals.new.activity.section.points.assignment',
    key: NewActivitySectionType.POINTS_ASSIGNMENT,
}
taskSectionMap[NewActivitySectionType.SCHEDULING] = {
    label: 'modals.new.activity.section.scheduling',
    key: NewActivitySectionType.SCHEDULING,
}

export const newsSectionMap = {}
newsSectionMap[NewActivitySectionType.EDITING_REASON] = {
    label: 'modals.new.activity.task.section.editing.reason',
    key: NewActivitySectionType.EDITING_REASON,
}
newsSectionMap[NewActivitySectionType.NEWS_TYPE] = {
    label: 'modals.new.activity.news.section.news.type',
    key: NewActivitySectionType.NEWS_TYPE,
}
newsSectionMap[NewActivitySectionType.MAIN_INFO] = {
    label: 'modals.new.activity.section.main.info',
    key: NewActivitySectionType.MAIN_INFO,
}
newsSectionMap[NewActivitySectionType.DISTRIBUTION] = {
    label: 'modals.new.activity.section.distribution',
    key: NewActivitySectionType.DISTRIBUTION,
}
newsSectionMap[NewActivitySectionType.POINTS_ASSIGNMENT] = {
    label: 'modals.new.activity.section.points.assignment',
    key: NewActivitySectionType.POINTS_ASSIGNMENT,
}
newsSectionMap[NewActivitySectionType.SCHEDULING] = {
    label: 'modals.new.activity.section.scheduling',
    key: NewActivitySectionType.SCHEDULING,
}

export const visitSectionMap: Record<string, ActivityStep> = {
    [NewActivitySectionType.EDITING_REASON]: {
        label: 'modals.new.activity.task.section.editing.reason',
        key: NewActivitySectionType.EDITING_REASON,
    },
    [NewActivitySectionType.MAIN_INFO]: {
        label: 'modals.new.activity.section.main.info',
        key: NewActivitySectionType.MAIN_INFO,
    },
    [NewActivitySectionType.ACTION]: {
        label: 'modals.new.activity.section.action',
        key: NewActivitySectionType.ACTION,
    },
    [NewActivitySectionType.POINTS_ASSIGNMENT]: {
        label: 'modals.new.activity.section.points.assignment',
        key: NewActivitySectionType.POINTS_ASSIGNMENT,
    },
    [NewActivitySectionType.SCHEDULING]: {
        label: 'modals.new.activity.section.scheduling',
        key: NewActivitySectionType.SCHEDULING,
    },
}
export const surveyTaskSectionMap: Record<string, ActivityStep> = {
    [NewActivitySectionType.EDITING_REASON]: {
        label: 'modals.new.activity.task.section.editing.reason',
        key: NewActivitySectionType.EDITING_REASON,
    },
    [NewActivitySectionType.MAIN_INFO]: {
        label: 'modals.new.activity.section.main.info',
        key: NewActivitySectionType.MAIN_INFO,
    },
    [NewActivitySectionType.ACTION]: {
        label: 'modals.new.activity.section.action',
        key: NewActivitySectionType.ACTION,
    },
    [NewActivitySectionType.DISTRIBUTION]: {
        label: 'modals.new.activity.section.distribution',
        key: NewActivitySectionType.DISTRIBUTION,
    },
    [NewActivitySectionType.POINTS_ASSIGNMENT]: {
        label: 'modals.new.activity.section.points.assignment',
        key: NewActivitySectionType.POINTS_ASSIGNMENT,
    },
    [NewActivitySectionType.SCHEDULING]: {
        label: 'modals.new.activity.section.scheduling',
        key: NewActivitySectionType.SCHEDULING,
    },
}
